export const captchaReasonsPartialPath = 'reasons'

export const unauthorizedCaptchaPath = '/captcha'
export const unauthorizedCaptchaReasonsPath = `/captcha/${captchaReasonsPartialPath}`

export const authorizationCaptchaPath = '/app/legacy/authorized/captcha'
export const authorizationCaptchaSettingPath = `/app/legacy/authorized/captcha/${captchaReasonsPartialPath}`
